export const IS_LOCAL_EDITION = process.env.REACT_APP_LOCAL_EDITION === "1";

